export function SliderChild(props: { image: string | File}) {
    return (
        <>
            <section className="banner rounded-0 rounded-5 mb-4 px-2" style={{ backgroundImage: `url(${props.image})` }}></section>
        </>
    )
}